export default __webpack_public_path__ + "static/media/43_desktop.68ae796a.jpg";